import React from 'react';
import { MODALS } from '../constants';
import { ERROR_MESSAGE } from '../constants/common.constants';
import { isResponseSuccess } from 'helpers';
import { redirectToRoute } from 'actions';
import checkIcon from 'assets/images/check-icon.svg';
import errorIcon from 'assets/images/close-icon.svg';

const hideCustomModal = () => (dispatch, getState) => {
  dispatch({
    type: MODALS.UPDATE_CUSTOM_MODEL_VISIBILITY,
    show: false
  });
};

const showCustomModal = () => (dispatch, getState) => {
  dispatch({
    type: MODALS.UPDATE_CUSTOM_MODEL_VISIBILITY,
    show: true
  });
};

// setting show = true assuming that when a modal is updated, it is desired to be shown.
const updateCustomModal = (
  show = true, title, body, onOk, onCancel, hideModal, showCloseButton, size, okLabel, cancelLabel, closeOnOk, dialogClassName, okBtnClassVal = 'btn btn-link text-primary'
) => (dispatch, getState) => {
  dispatch({
    type: MODALS.UPDATE_CUSTOM_MODEL,
    show: show,
    title: title,
    body: body,
    onOk: onOk,
    onCancel: onCancel,
    hideModal: hideModal,
    showCloseButton: showCloseButton,
    size: size,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    closeOnOk: closeOnOk,
    dialogClassName: dialogClassName,
    okBtnClassVal: okBtnClassVal
  });
};

export const customModalActions = {
  hideCustomModal,
  showCustomModal,
  updateCustomModal
};

const constructModalBody = (icon = checkIcon, message = '') => {
  const iconContainerStyle = {
    padding: '0.25rem',
    textAlign: 'center'
  };

  const iconStyle = {
    height: '5rem',
    width: '5rem'
  };

  const messageStyle = {
    padding: '0.5rem',
    textAlign: 'center',
    fontSize: '3.5vw'
  };

  return <div className='w-100 h-100'>
    <div style={iconContainerStyle}>
      <img style={iconStyle} src={icon} />
    </div>
    <div style={messageStyle} className='w-100'>
      {message}
    </div>
  </div>;
};

export const showServerResponse = (response, successMessage, errorMessage, redirection) => dispatch => {
  if (isResponseSuccess(response)) {
    if (successMessage) {
      dispatch(showSuccessModal(true, successMessage));
      setTimeout(() => {
        dispatch(showSuccessModal(false));
        if (typeof redirection === 'string') {
          dispatch(redirectToRoute(redirection)); // TODO: check if this will cause a history loop
        } else if (typeof redirection === 'function') {
          redirection();
        }
      }, MODALS.POP_UP_TIMEOUT);
    }
  } else {
    if (typeof redirection === 'string') {
      dispatch(redirectToRoute(redirection));
    }
    dispatch(showErrorModal(true, errorMessage || ERROR_MESSAGE));
    setTimeout(() => {
      dispatch(showErrorModal(false));
    }, MODALS.POP_UP_TIMEOUT);
  }
};

export const throwError = (redirection, errorMessage = ERROR_MESSAGE) => dispatch => {
  dispatch(showErrorModal(true, errorMessage));
  setTimeout(() => {
    dispatch(showErrorModal(false));
    if (redirection) { dispatch(redirectToRoute(redirection)); }
  }, MODALS.POP_UP_TIMEOUT);
};

export const showErrorModal = (show, errorMessage) => dispatch => {
  if (!show) {
    dispatch(hideCustomModal());
    return;
  }
  dispatch(updateCustomModal(true, null, constructModalBody(errorIcon, errorMessage)));
};

export const showSuccessModal = (show, successMessage) => dispatch => {
  if (!show) {
    dispatch(hideCustomModal());
    return;
  }
  dispatch(updateCustomModal(true, null, constructModalBody(checkIcon, successMessage)));
};
